import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Projects.scss";
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import ProjectsInfo from './ProjectInfo';

export default function Projects() {
    const [activeFilter, setActiveFilter] = useState('ALL');
    const [isVisible, setIsVisible] = useState(false);
    
    useEffect(() => {
        setIsVisible(true);
    }, []);
    
    // Define filter categories
    const filters = ['ALL', 'REACT', 'REACT NATIVE', 'WEB3', 'HTML CSS', 'RESTAPIS'];

    // Group projects by category
    const groupedProjects = {
        'REACT': ProjectsInfo.filter(project => project.category && project.category.toLowerCase() === 'react'),
        'REACT NATIVE': ProjectsInfo.filter(project => project.category && project.category.toLowerCase() === 'react native'),
        'WEB3': ProjectsInfo.filter(project => project.category && project.category.toLowerCase() === 'web3'),
        'HTML CSS': ProjectsInfo.filter(project => project.category && project.category.toLowerCase() === 'html css'),
        'RESTAPIS': ProjectsInfo.filter(project => project.category && project.category.toLowerCase() === 'restapis'),
        'ALL': ProjectsInfo.slice(0, 5)
    };

    const handleFilterClick = (filter) => {
        setActiveFilter(filter);
    };

    return (
        <Container fluid className="projects-section" id="projects">
            <Container>
                {/* Section Header */}
                <Row>
                    <Col xs={12}>
                        <div className="section-header text-center">
                            <h2 className="section-title">Projects</h2>
                            <p className="section-subtitle">Some of the ideas I've brought to life</p>
                        </div>
                    </Col>
                </Row>

                {/* Filter Buttons */}
                <Row>
                    <Col xs={12}>
                        <div className="filter-container text-center">
                            <div className="filter-buttons">
                                {filters.map((filter) => (
                                    <button
                                        key={filter}
                                        className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
                                        onClick={() => handleFilterClick(filter)}
                                    >
                                        {filter}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Projects Grid by Category */}
                <Row className="g-4">
                    {groupedProjects[activeFilter].length === 0 ? (
                        <Col xs={12} className="text-center">
                            <p>No projects found for this category.</p>
                        </Col>
                    ) : (
                        groupedProjects[activeFilter].map((project, index) => (
                            <Col key={project.id} lg={4} md={6} sm={12} className="project-col">
                                <Card className={`project-card ${isVisible ? 'fade-in' : ''}`} 
                                      style={{ animationDelay: `${index * 0.15}s` }}>
                                    {/* Project Image */}
                                    <div className="project-image-container">
                                        <img 
                                            src={project.img} 
                                            alt={project.name} 
                                            className="project-image"
                                        />
                                        <div className="project-overlay">
                                            <div className="project-links">
                                                <a 
                                                    href={project.github} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="project-link github-link"
                                                    title="View on GitHub"
                                                >
                                                    <FaGithub />
                                                </a>
                                                {project.web && (
                                                    <a 
                                                        href={project.web} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="project-link demo-link"
                                                        title="Live Demo"
                                                    >
                                                        <FaExternalLinkAlt />
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Project Content */}
                                    <Card.Body className="project-content">
                                        <h3 className="project-title">{project.name}</h3>
                                        <p className="project-description">{project.desc}</p>
                                        
                                        <div className="tech-stack">
                                            {project.stacks
                                                .replace(/[()]/g, '')
                                                .split(',')
                                                .map((tech, index) => (
                                                    <span key={index} className="tech-tag">
                                                        {tech.trim()}
                                                    </span>
                                                ))}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))
                    )}
                </Row>

                {/* More Projects Button */}
                <Row>
                    <Col xs={12}>
                        <div className="more-projects-container text-center">
                            <a 
                                href="https://github.com/mohit200008" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="more-projects-btn"
                            >
                                <span>More Projects</span>
                                <FaGithub className="github-icon" />
                            </a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}
